import { twMerge } from '@/lib/classname/twMerge'
import type { VariantProps } from 'class-variance-authority'
import { cva } from 'class-variance-authority'
import {
  Apple,
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  BadgeCheck,
  BadgePercent,
  BatteryFull,
  BellPlus,
  BellRing,
  Bike,
  Blend,
  Bolt,
  BookOpen,
  Boxes,
  Calendar,
  CalendarClock,
  CalendarDays,
  CarFront,
  ChartColumn,
  ChartNoAxesCombined,
  Check,
  CheckCircle2,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  ChevronsUpDown,
  CircleAlert,
  CircleCheck,
  CircleChevronDown,
  CircleChevronUp,
  CircleHelp,
  CirclePlus,
  CircleX,
  ClipboardCheck,
  ClipboardList,
  ClipboardSignature,
  Clock,
  Clock3,
  ClockPlus,
  Clover,
  Cog,
  Coins,
  Columns4,
  Container,
  Crosshair,
  Disc2,
  Download,
  Drill,
  DropletOff,
  Droplets,
  Earth,
  EllipsisVertical,
  Euro,
  Eye,
  Factory,
  FastForward,
  FileCheck,
  FileEdit,
  FileSpreadsheet,
  FileText,
  Files,
  FilterX,
  Flower2,
  Focus,
  Gift,
  Goal,
  Hand,
  Handshake,
  HardHat,
  Headphones,
  Heart,
  HeartHandshake,
  History,
  Image,
  Import,
  Info,
  IterationCw,
  Joystick,
  KeyRound,
  Laptop,
  LayoutDashboard,
  LayoutGrid,
  Leaf,
  LifeBuoy,
  Link,
  ListFilter,
  ListFilterPlus,
  LoaderCircle,
  Locate,
  Lock,
  LogOut,
  Mail,
  MapPin,
  MapPinCheck,
  Menu,
  MenuSquare,
  MessageCircle,
  MessagesSquare,
  Minus,
  Monitor,
  MonitorCheck,
  MousePointerClick,
  Package,
  PackageCheck,
  PackageOpen,
  PackageSearch,
  Paperclip,
  PartyPopper,
  PenSquare,
  Pencil,
  PencilLine,
  PencilRuler,
  Phone,
  Play,
  PlugZap,
  Plus,
  Pointer,
  PowerOff,
  Printer,
  QrCode,
  Quote,
  Recycle,
  RefreshCw,
  Ruler,
  ScanBarcode,
  Scroll,
  Search,
  Share,
  Share2,
  Shell,
  ShieldCheck,
  ShieldUser,
  Shirt,
  ShoppingBasket,
  SignalLow,
  SignalMedium,
  Siren,
  SlidersVertical,
  Smile,
  Sparkles,
  Sprout,
  SquareDashed,
  SquareDashedMousePointer,
  SquarePen,
  SquareUser,
  Star,
  Store,
  TabletSmartphone,
  Tag,
  Tags,
  Timer,
  TimerReset,
  ToyBrick,
  TrafficCone,
  Trash2,
  Trees,
  TriangleAlert,
  Truck,
  Unplug,
  UploadCloud,
  User,
  User2,
  UserCheck,
  UserCog,
  UserPlus,
  UserRound,
  Users,
  Users2,
  Wand,
  Wind,
  Wrench,
  X,
  Zap,
} from 'lucide-react'

// Simply add icon name here and on the lucide-react import to add it to the component
export const possibleIcons = {
  Apple,
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  BadgeCheck,
  BadgePercent,
  BatteryFull,
  BellPlus,
  BellRing,
  Bike,
  Blend,
  Bolt,
  BookOpen,
  Boxes,
  Calendar,
  CalendarClock,
  CalendarDays,
  CarFront,
  ChartColumn,
  ChartNoAxesCombined,
  Check,
  CheckCircle2,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronsUpDown,
  ChevronUp,
  CircleAlert,
  CircleCheck,
  CircleChevronDown,
  CircleChevronUp,
  CircleHelp,
  CirclePlus,
  CircleX,
  ClipboardCheck,
  ClipboardList,
  ClipboardSignature,
  Clock,
  Clock3,
  ClockPlus,
  Clover,
  Cog,
  Coins,
  Columns4,
  Container,
  Crosshair,
  Disc2,
  Download,
  Drill,
  DropletOff,
  Droplets,
  Earth,
  EllipsisVertical,
  Euro,
  Eye,
  Factory,
  FastForward,
  FileCheck,
  FileEdit,
  Files,
  FileSpreadsheet,
  FileText,
  FilterX,
  Flower2,
  Focus,
  Gift,
  Goal,
  Hand,
  Handshake,
  HardHat,
  Headphones,
  Heart,
  HeartHandshake,
  History,
  Image,
  Import,
  Info,
  IterationCw,
  Joystick,
  KeyRound,
  Laptop,
  LayoutDashboard,
  LayoutGrid,
  Leaf,
  LifeBuoy,
  Link,
  ListFilter,
  ListFilterPlus,
  LoaderCircle,
  Locate,
  Lock,
  LogOut,
  Mail,
  MapPin,
  MapPinCheck,
  Menu,
  MenuSquare,
  MessageCircle,
  MessagesSquare,
  Minus,
  Monitor,
  MonitorCheck,
  MousePointerClick,
  Package,
  PackageCheck,
  PackageOpen,
  PackageSearch,
  Paperclip,
  PartyPopper,
  Pencil,
  PencilLine,
  PencilRuler,
  PenSquare,
  Phone,
  Play,
  Plus,
  PlugZap,
  Pointer,
  PowerOff,
  Printer,
  QrCode,
  Quote,
  Recycle,
  RefreshCw,
  Ruler,
  ScanBarcode,
  Scroll,
  Search,
  Share,
  Share2,
  Shell,
  ShieldCheck,
  ShieldUser,
  Shirt,
  ShoppingBasket,
  SignalLow,
  SignalMedium,
  Siren,
  SlidersVertical,
  Smile,
  Sparkles,
  SquareDashed,
  SquareDashedMousePointer,
  SquarePen,
  SquareUser,
  Sprout,
  Star,
  Store,
  TabletSmartphone,
  Tag,
  Tags,
  Timer,
  TimerReset,
  ToyBrick,
  TrafficCone,
  Trash2,
  Trees,
  TriangleAlert,
  Truck,
  Unplug,
  UploadCloud,
  User,
  User2,
  UserCheck,
  UserCog,
  UserPlus,
  UserRound,
  Users,
  Users2,
  Wand,
  Wind,
  Wrench,
  X,
  Zap,
} as const

const iconSize = {
  sm: 'size-2',
  md: 'size-3',
  '2xl': 'size-6',
  '3xl': 'size-7',
} as const

const iconCva = cva('antialiased', {
  variants: {
    size: iconSize,
  },
})

export type IconProps = VariantProps<typeof iconCva> & {
  className?: string
}

export type IconSize = keyof typeof iconSize

export type TypeIcons = keyof typeof possibleIcons

export function isIconName(name: string): name is TypeIcons {
  return Object.keys(possibleIcons).includes(name)
}

type IconType = Record<TypeIcons, React.FC<IconProps>>

export const Icon: IconType = Object.keys(possibleIcons).reduce<IconType>((obj, key) => {
  const IconComponent = possibleIcons[key as TypeIcons]

  obj[key as TypeIcons] = ({ className, size = 'md' }: IconProps): React.ReactElement => (
    <IconComponent
      aria-hidden="true"
      data-testid={`icon/${key.toLowerCase()}`}
      className={twMerge(className, iconCva({ size }))}
    />
  )

  return obj
}, {} as IconType)
